export default __webpack_public_path__ + "static/media/transformation.3a72db59.gif";